// import { HttpClient } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class IndicatorService {
  constructor(
    private httpClient: HttpClient,
    @Inject('environment') private environment: any
  ) {}


  getIndicators() {
    return this.httpClient.get<any>(
      'assets/mock/indicators.json'
      // `${this.environment.trafficUrl}/city-indicators/`
    );
  }
  // getIndicators(): {[key:string]: number} {
  //   const data = {
  //     speedAvg: 21,
  //     incidentsCount: 150,
  //     so2level: 162,
  //     parkingPercentage: 150,
  //     subparkingPercentage: 32,
  //   }
  //   return data;
  // }
}
